import * as React from "react";
import { forwardRef } from "react";
const SvgExport = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 14, height: 17, viewBox: "0 0 14 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M0 12.5H2V15H12V12.5H14V17H0V12.5Z", fill: "#89A6FF" }), /* @__PURE__ */ React.createElement("path", { d: "M10.59 6.41L12 5L7 0L2 5L3.41 6.41L6 3.83L6 13H8L8 3.83L10.59 6.41Z", fill: "#89A6FF" }));
const ForwardRef = forwardRef(SvgExport);
export { ForwardRef as ReactComponent };
